import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import {
  DxDataGridModule,
  DxButtonModule, DxTreeListModule, DxGalleryModule, DxAutocompleteModule, DxHtmlEditorModule, DxToolbarModule,
  DxPopoverModule, DxPopupModule, DxTemplateModule, DxTabPanelModule, DxFormModule, DxRadioGroupModule, DxAccordionModule, DxSpeedDialActionModule, DxLoadPanelModule,
  DxSelectBoxModule, DxDataGridComponent, DxRangeSliderModule, DxNumberBoxModule, DxAccordionComponent, DxScrollViewModule
  , DxCheckBoxModule, DxSwitchModule
} from 'devextreme-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OrgchartModule } from '@dabeng/ng-orgchart';
import { ManagerApprovalModalComponent } from './manager-approval-modal/manager-approval-modal.component';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { NgxOrgChartModule } from 'ngx-org-chart';
import { ColorPickerModule } from 'ngx-color-picker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { TabViewModule } from 'primeng/tabview'
//Components
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { AgencyMasterComponent } from './agencyMaster/agency-master.component';
import { AgencyBranchChartComponent } from './agencyBranchChart/agency-branch-chart.component';
import { UsersComponent } from './users/users.component';
import { LoginComponent } from './login/login.component';
import { BranchInformationComponent } from './branchInformation/branch-information.component';
import { BranchListComponent } from './branchList/branch-list.component';
import { AgencyRightsComponent } from './agencyRights/agency-rights.component';
import { AgencyListComponent } from './agencyList/agency-list.component';
import { UserListComponent } from './userList/user-list.component';
import { SuppliersListComponent } from './suppliersList/suppliers-list.component';
import { SuppliersAddEditComponent } from './suppliersAddEdit/suppliers-add-edit.component';
import { CMSComponent } from './cms/cms.component';
import { CmsSubHeaderComponent } from './cms-sub-header/cms-sub-header.component';
import { CmsSubLandingComponent } from './cms-sub-landing/cms-sub-landing.component';
import { CmsSubDealsComponent } from './cms-sub-deals/cms-sub-deals.component';
import { CmsSubFSitemapComponent } from './cms-sub-fsitemap/cms-sub-fsitemap.component';
import { CmsSubFSocialComponent } from './cms-sub-fsocial/cms-sub-fsocial.component';
import { CmsSubFContactsComponent } from './cms-sub-fcontacts/cms-sub-fcontacts.component';
import { ContactUsComponent } from './contactus/contactus.component';
import { AboutUsComponent } from './aboutus/aboutus.component';
import { CmsSubContactUsComponent } from './cms-sub-contactus/cms-sub-contactus.component';
import { CmsAboutUsLandingComponent } from './cms-aboutuslanding/cms-aboutuslanding.component';
import { CmsAboutUsServicesComponent } from '././cms-aboutusservices/cms-aboutusservices.component';
import { CmsLogoComponent } from './cms-logo/cms-logo.component';
import { CmsAboutUsTimelineComponent } from './cms-aboutustimeline/cms-aboutustimeline.component';
import { RevenueManagementComponent } from './revenueManagement/revenue-management.component';
import { AgencySupplierRightsComponent } from './agencySupplierRights/agency-supplier-rights.component';
import { BeneficiaryAccountComponent } from './beneficiary-account/beneficiary-account.component';
import { BeneficiaryAccountsAllocationComponent } from './beneficiary-accounts-allocation/beneficiary-accounts-allocation.component';
import { CreateBeneficiaryAccountComponent } from './create-beneficiary-account/create-beneficiary-account.component';
import { RevenueManagementListComponent } from './revenueManagementList/revenue-management-list.component';
import { Agency_BranchGroupsComponent } from './agency_BranchGroups/agency_branch-groups.component';
import { Agency_BranchGroupListComponent } from './agency_BranchGroupList/agency_branch-group-list.component';
import { FlightSearchComponent } from './flightSearch/flight-search.component';
import { PaymentAddEditComponent } from './paymentAddEdit/payment-add-edit.component';
import { DepositTypeComponent } from './depositType/deposit-type.component';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { ModeOfPaymentComponent } from './modeOfPayment/mode-of-payment.component';
import { PaymentListComponent } from './paymentList/payment-list.component';

import { ManagerPaymentListComponent } from './managerPaymentList/manager-payment-list.component';

import {  ManagerOnlineRequestListComponent } from './managerOnlineRequestList/manager-online-request-list.component';
import { OfflineRequestComponent } from './offlineRequestList/offline-request.component';
import { OfflineRequestAddEditComponent } from './offlineRequestAddEdit/offline-request-add-edit.component'
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { PassengerInfoComponent } from './passengerInfo/passengerInfo.component';
import { NoRightClickDirective } from './no-right-click.directive';
import { ManagerListComponent } from './managerList/manager-list.component';
import { BookingListComponent } from './bookingList/bookingList.component';
import { TicketIssuanceComponent } from './ticket-issuance/ticket-issuance.component';
import { AirportManageComponent } from './airport-manage/airport-manage.component';
import { OfflineMyBookingTktListComponent } from './offline-my-booking-tkt-list/offline-my-booking-tkt-list.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { RefundTicketOnlineComponent } from './refund-ticket-online/refund-ticket-online.component';
import { HomeDataResolve } from './data-Resolve.resolve';

import { AirlinesMasterComponent } from './airlines-master/airlines-master.component';
import { BookingListSearchCriteriaComponent } from './booking-list-search-criteria/booking-list-search-criteria.component';
import { BackOfficeAccountsComponent } from './back-office-accounts/back-office-accounts.component';
import { ContactUsSubComponent } from './contact-us-sub/contact-us-sub.component';
import { AboutUsSubComponent } from './about-us-sub/about-us-sub.component';
import { FooterComponent } from './footer/footer.component';
import { ImportPnrComponent } from './import-pnr/import-pnr.component';
import { ImportPnrListComponent } from './import-pnr-list/import-pnr-list.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { VoidRevenueManagementComponent } from './void-revenue-management/void-revenue-management.component';
import { RefundRevenueComponent } from './refund-revenue/refund-revenue.component';
import { NavBarMainLoginComponent } from './nav-bar-main-login/nav-bar-main-login.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { ImportRevenueManagementComponent } from './ImportPNRrevenueManagement/importrevenue-management.component'
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsofuseComponent } from './termsofuse/termsofuse.component';
import { CurrencyConversionComponent } from '../app/currency-conversion/currency-conversion.component';
import { BeneficaryDetailsListComponent } from '../app/beneficary-details-list/beneficary-details-list.component';
import { OfflineTicketIssueComponent } from './offlineTicketIssue/offline-ticket-issue.component';
import { PricingandstructureComponent } from './pricingandstructure/pricingandstructure.component';
import { RefundpolicyComponent } from './refundpolicy/refundpolicy.component';
import { ManagersComponent } from './managers/managers.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { CompanyMasterComponent } from './companyMaster/companyMaster.component';
import { DialogModule } from 'primeng/dialog';
import { GroupTicketComponent } from './groupTicket/groupTicket.component';
import { CalendarModule } from 'primeng/calendar';
import { BadgeModule } from 'primeng/badge';
import { DropdownModule } from 'primeng/dropdown';
import { FilterService } from 'primeng/api';
import { MultiSelectModule } from 'primeng/multiselect';
import { GroupTicketListComponent } from './groupTicketList/groupTicketList.component';
import { FlyDubaiModifyComponent } from './flyDubaiModification/flydubai-modify.component';
import { ToastModule } from 'primeng/toast';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PanelModule } from 'primeng/panel';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';

import { AccordionModule } from 'primeng/accordion';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { InputSwitchModule } from 'primeng/inputswitch';
import { StatementOfAccountComponent } from './statement-of-account/statement-of-account.component'
//20-jan-24
import { OfflineBookingCreateComponent } from './offlineBookingRequest/offlineBookingRequest.component';
import { ConfigService } from './config.service';
import { RateOfExchangeComponent } from './rate-of-exchange/rate-of-exchange.component';
import { RateOfExchangeListComponent } from './rate-of-exchange-list/rate-of-exchange-list.component';
import { FlightResultsNewComponent } from './flightResultsNew/flight-results-new.component';
import { PostAncillaryComponent } from './post-Ancillary/post-ancillary.component';
import { EmiratesModificationComponent } from './emirates-modification/emirates-modification.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ImportPnrEntryComponent } from './import-pnr-entry/import-pnr-entry.component';

import { GroupRevenueReportComponent } from './group-revenue-report/group-revenue-report.component';
import { RevenueReportComponent } from './revenueReport/revenueReport.component';
import { AddSuppliersComponent } from './add-suppliers/add-suppliers.component';
import { ModifyAirItineraryComponent } from './modify-air-itinerary/modify-air-itinerary.component';
import { SpiceModificationComponent } from './SpiceModification/spice-modification.component';
import { AirblueModifyComponent } from './airblue-Modify/airblue-modify.component';

import { GroupTicketForUserNewComponent } from './group-ticket-for-user-new/group-ticket-for-user-new.component';
import { AddGroupTitleComponent } from './add-group-title/add-group-title.component';

import { TravelInsuranceComponent } from './travel-insurance/travel-insurance.component';
import { TravelInsuranceIssuanceComponent } from './travel-insurance-issuance/travel-insurance-issuance.component';
import { TravelInsuranceBookingComponent } from './travel-insurance-booking/travel-insurance-booking.component';
import { SidebarModule } from 'primeng/sidebar';


import { TravelInsurancePassengersComponent } from './travel-insurance-passengers/travel-insurance-passengers.component';
import { TravelInsurancePlanResultsComponent } from './travel-insurance-plan-results/travel-insurance-plan-results.component';
import { TravelInsuranceCancellationComponent } from './travel-insurance-cancellation/travel-insurance-cancellation.component';
import { UnitedInsuranceComponent } from './united-insurance/united-insurance.component';
import { UnitedInsuranceHomeComponent } from './united-insurance-home/united-insurance-home.component';
//end
import { InputMaskModule } from 'primeng/inputmask';
import { HomeNewComponent } from './home-new/home-new.component';
import { CarouselModule } from 'primeng/carousel';

import { CmsLoginSliderImagesComponent } from './cms-login-slider-images/cms-login-slider-images.component';
import { FlightSearchNew1Component } from './flight-search-new1/flight-search-new1.component';
import { RegisterComponent } from './register/register.component';
import { RegisterListComponent } from './register/register-list/register-list.component';
import { ForgetPasswordComponent } from './ForgetPassword/forget-password.component';
import { ManagerProficiencyReportComponent } from './manager-proficiency-report/manager-proficiency-report.component';
import { ChartModule } from 'primeng/chart';
import { MasterPassengerInfoComponent } from './master-passenger-info/master-passenger-info.component';
import { MasterPassengerInfoListComponent } from './master-passenger-info-list/master-passenger-info-list.component';
import { TravelPortModificationComponent } from './travel-port-modification/travel-port-modification.component';
import { OfflineSupplierListComponent } from './offline-supplier-list/offline-supplier-list.component';
import { OfflineSupplierComponent } from './offline-supplier/offline-supplier.component';
import { ChatComponent } from './chat/chat.component';
import { OfflineBackOfficeReportComponent } from './offline-back-office-report/offline-back-office-report.component';
import { AuthInterceptor } from './AuthInterceptor';
import { OfflineTicketComponent } from './offline-new/offline-ticket/offline-ticket.component';
import { OfflineBookingComponent } from './offline-new/offline-booking/offline-booking.component';
import { OfflineReissueComponent } from './offline-new/offline-reissue/offline-reissue.component';
import { OfflineRefundComponent } from './offline-new/offline-refund/offline-refund.component';
import { OfflineVoidComponent } from './offline-new/offline-void/offline-void.component';
import { OfflineFlightSearchComponent } from './offline-new/offline-flight-search/offline-flight-search.component';
import { ManagerOfflineRequestListComponent } from './managerOfflineRequestList/manager-offline-request-list.component';
import { OfflineNewComponent } from './offline-new/offline-new.component';
import { AutoCapitalizeDirective } from './offline-new/auto-capitalize.directive';
import { TravelInsuranceRevenueManagementComponent } from './travelInsurance-Revenue-Management/travelInsurance-Revenue-Management.component';
import { CheckboxModule } from "primeng/checkbox";
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ZeusBookedPoliciesComponent } from './zeus-booked-policies/zeus-booked-policies.component';
import { BackOfficeInsuranceReportComponent } from './back-office-insurance-report/back-office-insurance-report.component';
import { PermissionGuard } from './guards/permission.guard';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { UmraOffersComponent } from './umra-offers/umra-offers.component';
import { UmraShortlistedPackageComponent } from './umra-shortlisted-package/umra-shortlisted-package.component';
import { UmraManagerApprovalListComponent } from './umra-manager-approval-list/umra-manager-approval-list.component';
import { UmraReservationUserRequestsListComponent } from './umra-reservation-user-requests-list/umra-reservation-user-requests-list.component';
import { UmraCustomPackagesAddComponent } from './umra-custom-packages-add/umra-custom-packages-add.component';
import { UmraPdfTemplateComponent } from './umra-offers/umra-pdf-template/umra-pdf-template.component';
import { UmraPackageManagementComponent } from './umra-package-management/umra-package-management.component';
import { HotelManagementComponent } from './hotel-management/hotel-management.component';
import { TravelportPccComponent } from './travelport-pcc/travelport-pcc.component';
import { ImportPnrForOfflineIssuedComponent } from './import-pnr-for-offline-issued/import-pnr-for-offline-issued.component';
import { HotelGalleryComponent } from './hotel-gallery/hotel-gallery.component';
import { DataFetchedFromOfflineComponent } from './data-fetched-from-offline/data-fetched-from-offline.component';
import { UmraSupplierManagementComponent } from './umra-supplier-management/umra-supplier-management.component';
import { PackageCardComponent } from './umra-offers/package-card.component';
import { LayoutModule } from '@angular/cdk/layout';

export function initializeApp(configService: ConfigService) {
  return () => configService.loadConfigData().toPromise();
}
@NgModule({
  declarations: [
    FlightSearchNew1Component,
    HomeNewComponent,
    AppComponent,
    MasterPassengerInfoComponent,
    MasterPassengerInfoListComponent,
    AirblueModifyComponent,
    SpiceModificationComponent,
    ModifyAirItineraryComponent,
    ImportPnrEntryComponent,
    GroupRevenueReportComponent,
    RevenueReportComponent,
    AddSuppliersComponent,
    FlightResultsNewComponent,
    RateOfExchangeComponent,
    RateOfExchangeListComponent,
    NavMenuComponent,
    NavBarMainLoginComponent,
    ManagersComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    CMSComponent,
    AgencyMasterComponent,
    AgencyBranchChartComponent,
    UsersComponent,
    LoginComponent,
    BranchInformationComponent,
    BranchListComponent,
    AgencyListComponent,
    AgencyRightsComponent,
    UserListComponent,
    SuppliersListComponent,
    SuppliersAddEditComponent,
    CmsSubHeaderComponent,
    CmsSubLandingComponent,
    CmsSubDealsComponent,
    CmsSubFSitemapComponent,
    CmsSubFSocialComponent,
    CmsSubFContactsComponent,
    ContactUsComponent,
    CurrencyConversionComponent,
    AboutUsComponent,
    CmsSubContactUsComponent,
    CmsAboutUsLandingComponent,
    CmsAboutUsServicesComponent,
    CmsAboutUsTimelineComponent,
    CmsLogoComponent,
    BeneficiaryAccountComponent,
    CreateBeneficiaryAccountComponent,
    RevenueManagementComponent,
    AgencySupplierRightsComponent,
    BeneficiaryAccountsAllocationComponent,
    Agency_BranchGroupsComponent,
    RevenueManagementListComponent,
    Agency_BranchGroupListComponent,
    FlightSearchComponent,
    PaymentAddEditComponent,
    DepositTypeComponent,
    ModeOfPaymentComponent,
    PaymentListComponent,
    ManagerPaymentListComponent,
    ManagerOfflineRequestListComponent,
    OfflineRequestComponent,
    OfflineRequestAddEditComponent,
    PassengerInfoComponent,
    NoRightClickDirective,
    ManagerListComponent,
    BookingListComponent,
    TicketIssuanceComponent,
    AirportManageComponent,
    OfflineMyBookingTktListComponent,
    RefundTicketOnlineComponent,
    AirlinesMasterComponent,
    BookingListSearchCriteriaComponent,
    BackOfficeAccountsComponent,
    AboutUsSubComponent,
    FooterComponent,
    ContactUsSubComponent,
    ImportPnrComponent,
    ImportPnrListComponent,
    PageNotFoundComponent,
    VoidRevenueManagementComponent,
    RefundRevenueComponent,
    ImportRevenueManagementComponent,
    PrivacyPolicyComponent,
    TermsofuseComponent,
    BeneficaryDetailsListComponent,
    OfflineTicketIssueComponent,
    EmiratesModificationComponent,
    PricingandstructureComponent,
    RefundpolicyComponent,
    CompanyMasterComponent,
    PostAncillaryComponent,
    GroupTicketComponent,
    GroupTicketListComponent,
    FlyDubaiModifyComponent,
    TravelPortModificationComponent,
    StatementOfAccountComponent,
     //20-jan-24
    OfflineBookingCreateComponent,
    GroupTicketForUserNewComponent,
    AddGroupTitleComponent,
    TravelInsuranceComponent,
    TravelInsuranceIssuanceComponent,
    TravelInsuranceBookingComponent,
    TravelInsurancePassengersComponent,
    TravelInsurancePlanResultsComponent,
    TravelInsuranceCancellationComponent,
    TravelInsuranceRevenueManagementComponent,
    UnitedInsuranceComponent,
    ManagerApprovalModalComponent,
    UnitedInsuranceHomeComponent,
    CmsLoginSliderImagesComponent,
    RegisterComponent,
    RegisterListComponent,
    ForgetPasswordComponent,
    ManagerProficiencyReportComponent,
    OfflineSupplierListComponent,
    OfflineSupplierComponent,
    ChatComponent,
    OfflineBackOfficeReportComponent,
    OfflineTicketComponent,
    OfflineBookingComponent,
    OfflineReissueComponent,
    OfflineRefundComponent,
    OfflineVoidComponent,
    OfflineFlightSearchComponent,
    ManagerOnlineRequestListComponent,
    OfflineNewComponent,
    AutoCapitalizeDirective,
    ZeusBookedPoliciesComponent,
    BackOfficeInsuranceReportComponent,
    UnauthorizedComponent,
    UmraOffersComponent,
    UmraShortlistedPackageComponent,
    UmraManagerApprovalListComponent,
    UmraReservationUserRequestsListComponent,
    UmraCustomPackagesAddComponent,
    UmraPdfTemplateComponent,
    UmraPackageManagementComponent,
    TravelportPccComponent,
    ImportPnrForOfflineIssuedComponent,
    HotelManagementComponent,
    HotelGalleryComponent,
    DataFetchedFromOfflineComponent,
    UmraSupplierManagementComponent,
    PackageCardComponent
     //end
  ],
  entryComponents: [ManagerApprovalModalComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    NgxSliderModule,
    ChartModule,
    CarouselModule,
    TabViewModule,
    ToastModule,
    ScrollPanelModule,
    DxCheckBoxModule,
    DxSwitchModule,
    ConfirmDialogModule,
    DxPopoverModule,
    DxPopupModule,
    DxScrollViewModule,
    DxTemplateModule,
    DxTabPanelModule,
    InputSwitchModule,
    TableModule,
    DxFormModule,
    ScrollingModule,
    InputMaskModule,
    DynamicDialogModule,
    SkeletonModule,
    BadgeModule,
    RadioButtonModule,
    ProgressBarModule,
    DxRangeSliderModule, DxNumberBoxModule,
    FontAwesomeModule,
    DxRadioGroupModule,
    DxLoadPanelModule,
    DxAccordionModule,
    DxSpeedDialActionModule,
    DxSelectBoxModule,
    HttpClientModule,
    TooltipModule,
    FormsModule,
    NgxUsefulSwiperModule,
    PanelModule,
    DxGalleryModule,
    DxDataGridModule,
    DxButtonModule,
    DxTreeListModule,
    DxHtmlEditorModule,
    DxAutocompleteModule,
    DxToolbarModule,
    NgSelectModule,
    OrgchartModule,
    AccordionModule,
    NgbModule,
    OrganizationChartModule,
    NgxOrgChartModule,
    ColorPickerModule,
    AutoCompleteModule,
    CalendarModule,
    DropdownModule,
    MultiSelectModule,
    DialogModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    SidebarModule,
    CheckboxModule,
    InputTextModule,
    ButtonModule,
    LayoutModule,
    RouterModule.forRoot([
      {
        path: '', component: HomeNewComponent, pathMatch: 'full'
      },

      {
        path: 'home', component: HomeNewComponent
      },
      { path: 'sliderImages', component: CmsLoginSliderImagesComponent },
      { path: 'counter', component: CounterComponent },
      { path: 'fetch-data', component: FetchDataComponent },
      { path: 'users', component: UsersComponent, canActivate: [PermissionGuard], data: { permissions: ['users'] } },
      { path: 'branchInformation', component: BranchInformationComponent },
      { path: 'agencyMaster', component: AgencyMasterComponent },
      { path: 'agencyList', component: AgencyListComponent },
      { path: 'branchList', component: BranchListComponent },
      { path: 'agencyRights', component: AgencyRightsComponent, canActivate: [PermissionGuard], data: { permissions: ['accountManagement'] } },
      { path: 'userList', component: UserListComponent, canActivate: [PermissionGuard], data: { permissions: ['users'] } },
      { path: 'agencyBranchChart', component: AgencyBranchChartComponent },
      //{ path: 'home', component: HomeComponent },
      { path: 'suppliersList', component: SuppliersListComponent },
      { path: 'suppliersAddEdit', component: SuppliersAddEditComponent },
      { path: 'cms', component: CMSComponent, canActivate: [PermissionGuard], data: { permissions: ['cms'] } },
      { path: 'currency-conversion', component: CurrencyConversionComponent, canActivate: [PermissionGuard], data: { permissions: ['currency'] } },
      { path: 'cms-add-header', component: CmsSubHeaderComponent, canActivate: [PermissionGuard], data: { permissions: ['cms'] } },
      { path: 'cms-add-landing', component: CmsSubLandingComponent },
      { path: 'cms-add-deals', component: CmsSubDealsComponent },
      { path: 'cms-add-footer-sitemap', component: CmsSubFSitemapComponent },
      { path: 'cms-add-footer-social', component: CmsSubFSocialComponent },
      { path: 'cms-add-footer-contacts', component: CmsSubFContactsComponent },
      { path: 'app-contactus', component: ContactUsComponent },
      { path: 'app-aboutus', component: AboutUsComponent },
      { path: 'app-cms-sub-contactus', component: CmsSubContactUsComponent },
      { path: 'app-cms-aboutuslanding', component: CmsAboutUsLandingComponent },
      { path: 'app-cms-aboutusservices', component: CmsAboutUsServicesComponent },
      { path: 'app-cms-aboutustimeline', component: CmsAboutUsTimelineComponent },
      { path: 'app-cms-logo', component: CmsLogoComponent },
      { path: 'revenueManagement', component: RevenueManagementComponent, canActivate: [PermissionGuard], data: { permissions: ['revenueManagement'] } },
      { path: 'agencySupplierRights', component: AgencySupplierRightsComponent, canActivate: [PermissionGuard], data: { permissions: ['supplierManagement'] } },
      { path: 'allocateBeneficiaryAccount', component: BeneficiaryAccountsAllocationComponent },
      { path: 'update-beneficiary-account', component: BeneficiaryAccountComponent },
      { path: 'beneficiary-account', component: CreateBeneficiaryAccountComponent },
      { path: 'agency_BranchGroups', component: Agency_BranchGroupsComponent },
      { path: 'agency_BranchGroupList', component: Agency_BranchGroupListComponent },
      { path: 'revenueManagementList', component: RevenueManagementListComponent, canActivate: [PermissionGuard], data: { permissions: ['revenueManagement'] } },
      { path: 'offlineTicketIssue', component: OfflineTicketIssueComponent },
      { path: 'pricingandstructure', component: PricingandstructureComponent },
      { path: 'flightSearch', component: FlightSearchNew1Component},
      { path: 'paymentAddEdit', component: PaymentAddEditComponent, canActivate: [PermissionGuard], data: { permissions: ['addPayment' ,'approvePayment'] } },
      { path: 'paymentList', component: PaymentListComponent, canActivate: [PermissionGuard], data: { permissions: ['addPayment'] } },
      { path: 'managerPaymentList', component: ManagerPaymentListComponent, canActivate: [PermissionGuard], data: { permissions: ['approvePayment'] } },
      { path: 'flightResults', component: FlightResultsNewComponent },
      { path: 'offlineRequestList', component: OfflineRequestComponent },
      { path: 'offlineRequestAddEdit', component: OfflineRequestAddEditComponent },
      { path: 'managerOnlineRequestList', component: ManagerOnlineRequestListComponent },
      { path: 'managerOfflineRequestList', component: ManagerOfflineRequestListComponent, canActivate: [PermissionGuard], data: { permissions: ['managerOfflineRequestList'] } },
      { path: 'passengerInfo', component: PassengerInfoComponent },
      { path: 'managerList', component: ManagerListComponent },
      { path: 'bookingList', component: BookingListComponent, canActivate: [PermissionGuard], data: { permissions: ['bookings', 'viewBookings'], permissionCheckType: 'any' } },
      { path: 'ticket-issuance', component: TicketIssuanceComponent },
      { path: 'airport', component: AirportManageComponent, canActivate: [PermissionGuard], data: { permissions: ['airport'] } },
      { path: 'offline-my-booking-tkt-list', component: OfflineMyBookingTktListComponent },
      { path: 'refund-ticket-online', component: RefundTicketOnlineComponent },
      { path: 'airline', component: AirlinesMasterComponent, canActivate: [PermissionGuard], data: { permissions: ['airline'] } },
      { path: 'BookingSearch', component: BookingListSearchCriteriaComponent },
      { path: 'B2BbackOffice', component: BackOfficeAccountsComponent },
      { path: 'about-us', component: AboutUsSubComponent },
      { path: 'contact-us', component: ContactUsSubComponent },
      { path: 'importPNR', component: ImportPnrComponent, canActivate: [PermissionGuard], data: { permissions: ['importPnr'] } },
      { path: 'importPNRList', component: ImportPnrListComponent},
      { path: 'voidRevenue', component: VoidRevenueManagementComponent},
      { path: 'refundRevenue', component: RefundRevenueComponent },
      { path: 'importRevenue', component: ImportRevenueManagementComponent},
      { path: 'privacyPolicy', component: PrivacyPolicyComponent},
      { path: 'termsofuse', component: TermsofuseComponent},
      { path: 'beneficaryDetails', component: BeneficaryDetailsListComponent},
      { path: 'refundpolicy', component: RefundpolicyComponent },
      { path: 'addManagers', component: ManagersComponent },
      { path: 'postAncillary', component: PostAncillaryComponent },
      { path: 'groupTicket', component: GroupTicketComponent, canActivate: [PermissionGuard], data: { permissions: ['groupTicketRight'] } },
      { path: 'flyDubaiModify', component: FlyDubaiModifyComponent },
      { path: 'flyDubaiModify', component: AirblueModifyComponent },
      { path: 'spiceModify', component: SpiceModificationComponent },
      { path: 'flightResultModify', component: ModifyAirItineraryComponent },
      { path: 'StatementofAccount', component: StatementOfAccountComponent, canActivate: [PermissionGuard], data: { reports: ['Statement of Account'] } },
      { path: 'RateOfExchange', component: RateOfExchangeComponent, canActivate: [PermissionGuard], data: { permissions: ['currency'] } },
      { path: 'RateOfExchangeList', component: RateOfExchangeListComponent, canActivate: [PermissionGuard], data: { permissions: ['currency'] } },
      { path: 'paymentAddEdit/:response/:id', component: PaymentAddEditComponent, canActivate: [PermissionGuard], data: { permissions: ['approvePayment' ,'bookings', 'viewBookings'], permissionCheckType: 'any' } },
      { path: 'offlineBookingRequestCreate', component: OfflineBookingCreateComponent },
      { path: 'emiratesModify', component: EmiratesModificationComponent },
      { path: 'importPnrEntry', component: ImportPnrEntryComponent },
      { path: 'GroupRevenueReport', component: GroupRevenueReportComponent, canActivate: [PermissionGuard], data: { reports: ['Revenue Report', 'Group Revenue Report'] } },
      { path: 'revenueReport', component: RevenueReportComponent, canActivate: [PermissionGuard], data: { reports: ['Revenue Report', 'Group Revenue Report'] } },
      { path: 'addSuppliers', component: AddSuppliersComponent, canActivate: [PermissionGuard], data: { permissions: ['supplierManagement'] } },
      { path: "groupTicketForUserNew", component: GroupTicketForUserNewComponent, canActivate: [PermissionGuard], data: { permissions: ['groupTicketCreateRight'] } },
      { path: "addGroupTitle", component: AddGroupTitleComponent },
      { path: 'zeus-insurance-home', component: TravelInsuranceComponent, canActivate: [PermissionGuard], data: { permissions: ['insuranceRight'] } },
      { path: 'united-insurance-home', component: UnitedInsuranceHomeComponent, canActivate: [PermissionGuard], data: { permissions: ['insuranceRight'] } },
      { path: 'insurance-issuance', component: TravelInsuranceIssuanceComponent, canActivate: [PermissionGuard], data: { permissions: ['insuranceIssuanceRight'] } },
      { path: 'plans', component: TravelInsurancePlanResultsComponent },
      { path: 'insured-passengers', component: TravelInsurancePassengersComponent },
      { path: 'search-booked-plan/:id', component: TravelInsuranceBookingComponent },
      { path: 'cancel-insurance-policy', component: TravelInsuranceCancellationComponent, canActivate: [PermissionGuard], data: { permissions: ['insuranceCancelRight'] } },
      { path: 'travel-insurance-revenue-management', component: TravelInsuranceRevenueManagementComponent },
      { path: 'united-travel-insurance', component: UnitedInsuranceComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'registerList', component: RegisterListComponent },
      { path: 'managerProficiencyReport', component: ManagerProficiencyReportComponent },
      { path: 'travelPortModify', component: TravelPortModificationComponent },
      { path: 'MasterSupplierPassenger', component: MasterPassengerInfoComponent },
      { path: 'MasterSupplierPassengerlist', component: MasterPassengerInfoListComponent },
      { path: 'offlineSupplierList', component: OfflineSupplierListComponent },
      { path: 'offlineSupplier', component: OfflineSupplierComponent },
      { path: 'chatapp', component: ChatComponent },
      { path: 'offlinebackoffice', component: OfflineBackOfficeReportComponent },
      { path: 'offlineTicket', component: OfflineTicketComponent, canActivate: [PermissionGuard], data: { permissions: ['offlineTicket'] } },
      { path: 'offlineBooking', component: OfflineBookingComponent, canActivate: [PermissionGuard], data: { permissions: ['offlineBooking'] } },
      { path: 'offlineReissue', component: OfflineReissueComponent, canActivate: [PermissionGuard], data: { permissions: ['offlineResissue'] } },
      { path: 'offlineRefund', component: OfflineRefundComponent, canActivate: [PermissionGuard], data: { permissions: ['offlineRefund'] } },
      { path: 'offlineVoid', component: OfflineVoidComponent, canActivate: [PermissionGuard], data: { permissions: ['offlineVoid'] } },
      { path: 'offlineFlightSearch', component: OfflineFlightSearchComponent},
      { path: 'zeusBookedPolicy', component: ZeusBookedPoliciesComponent, canActivate: [PermissionGuard], data: { permissions: ['insuranceBookedViewRight'] } },
      { path: 'companyMaster', component: CompanyMasterComponent },
      { path: 'insurance-report', component: BackOfficeInsuranceReportComponent, canActivate: [PermissionGuard], data: { reports: ['Insurance Report'] } }, // Unauthorized page
      { path: 'umra-offers', component: UmraOffersComponent },
      { path: 'shortlisted-package/:id', component: UmraShortlistedPackageComponent },
      { path: 'package-management', component: UmraPackageManagementComponent },
      {
        path: 'umra-reservation-requests', component: UmraManagerApprovalListComponent,
        //canActivate: [PermissionGuard], data: { permissions: ['umraManagerApprovalList'] }
      },
      {
        path: 'travelport-pcc-for-import-pnr', component: TravelportPccComponent,
        //canActivate: [PermissionGuard], data: { permissions: ['umraManagerApprovalList'] }
      },
      {
        path: 'my-umra-reservation-requests', component: UmraReservationUserRequestsListComponent,
        //canActivate: [PermissionGuard], data: { permissions: ['umraReservationUserRequestsList'] }
      },
      { path: 'unauthorized', component: UnauthorizedComponent },
      { path: 'add-new-umra-offer', component: UmraCustomPackagesAddComponent },
      { path: 'hotel-management', component: HotelManagementComponent },
      { path: 'fetch-data-from-offline-id', component: ImportPnrForOfflineIssuedComponent },
      { path: 'create-invoice-from-pnr', component: DataFetchedFromOfflineComponent },
      { path: 'umra-supplier-management', component: UmraSupplierManagementComponent },
      {
        path: '**',
        component: PageNotFoundComponent
      },  
    ])
  ],

  providers: [DxDataGridComponent,  PrimeNGConfig, FilterService, ConfirmationService, MessageService,
    ConfigService, DialogService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true,
    }, {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },],
  bootstrap:[AppComponent]
})

//@NgModule({
//  imports: [BsDatepickerModule.forRoot()]
//})
export class AppModule { }
